export { RatingTable } from './RatingTable';
